<template>
  <div>
    <label v-if="titulo != null">{{titulo}}</label>
    <label v-for="opcao in listaDeOpcoes" :key="opcao" class="checkbox">
      <input 
        type="checkbox"
        :id="opcao?.id"
        :value="opcao.valor"
        v-model="valoresSelecionados"
        :checked="opcao.isSelecionada"
        :title="opcao.title || opcao.label"
        @change="$emit('update:valoresSelecionados', valoresSelecionados)"
      />
      {{opcao.label}}
    </label>
  </div>
</template>

<script>

export default {
  name: "TrfCheckboxFields",
  props: {
    titulo: {
      type: [String],
      required: false,
      default: null
    },
    listaDeOpcoes: {
      type: [Array],
      required: true,
    },
    required: {
      type: [Boolean],
      required: false,
      default: false
    },
    validate: {
      type: [Function],
      required: false,
      default: function validacaoBasica() {
        if(!!this && !this.required) {
          return true;
        }

        if(!!this && this.valoresSelecionados?.length == 0) {
          return false;
        }
      }()
    },
    isValid: {
      type: [Boolean],
      required: false,
      default: !!this && this.validate()
    },
  },
  data() {
    return {
      valoresSelecionados: this._adquirirOpcoesSelecionadas()
    };
  },
  methods: {
    validacaoBasica() {
      if(!this.required) {
        return true;
      };

      if(this.valoresSelecionados?.length == 0) {
        return false;
      }
    },
    limparCampos() {
      this.valoresSelecionados = [];
      this.$emit('update:valoresSelecionados', this.valoresSelecionados);
    },
    _adquirirOpcoesSelecionadas() {
      const valoresSelecionados = [];
      this.listaDeOpcoes?.forEach(opcao => {
        if(opcao.isSelecionada) {
          valoresSelecionados.push(opcao.valor);
        }
      })
      this.$emit('update:valoresSelecionados', valoresSelecionados);
      return valoresSelecionados;
    },
    _selecionarDefault() {
      this._adquirirOpcoesSelecionadas();
    },
    selecionarCheckboxes() {
      this.valoresSelecionados =  this._adquirirOpcoesSelecionadas();
    },
  },
  mounted() {
    this._selecionarDefault();
  }, 
};
</script>

<style lang="scss" scoped>
$light-grey: #cccccc;
$dark-grey: #333333;
$orange: #f90;
$dark-orange: #f63;
$is-3: 0.75rem;
$is-6: 3rem;
$is-5: 1.5rem;

label.checkbox:not(:last-child) {
  margin-right:$is-5;
}
</style>
